@if (orphanedTileData$ | async; as orphanedTileData) {
  <div>
    <ziro-dashboard-tile
      [isLoading]="orphanedTileData.isLoading"
      [tile]="orphanedTileData.tileStatus"
    ></ziro-dashboard-tile>
  </div>
}
